<ng-container *ngIf="isGetFeaturesDone">
  <div class="order-history-filter" *ngIf="this.filterType === 0">
    <h1 tabindex="0">{{ 'orders.orderHistory' | cxTranslate }}</h1>

    <div class="order-filter-wrapper">
      <p class="label filter-result" style="margin-bottom: 0">
        {{ 'orders.filterResults' | cxTranslate }}
      </p>
      <p class="label filter" style="margin-bottom: 0">{{ 'orders.filter' | cxTranslate }}</p>
    </div>
    <div class="filter-count-clear">
      <span class="filter-count"> {{ this.totalNumberOfResults }} {{ 'orders.items' | cxTranslate }} </span>
      <span class="filter-clear" *ngIf="isDesktop$ | async">
        <button class="tertiary-btn" mat-button (click)="onClearFilters()">
          {{ 'orders.clearFilters' | cxTranslate }}
        </button>
      </span>
    </div>
    <hr />
    <div class="order-search-wrapper">
      <p class="label">{{ 'orders.search' | cxTranslate }}</p>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'orders.searchBy' | cxTranslate }}</mat-label>
        <mat-select [(ngModel)]="selected" (ngModelChange)="onFilterSelection()">
          <mat-select-trigger>
            <ng-container [ngSwitch]="selected">
              <ng-container *ngSwitchDefault>{{ 'orders.orderNumber' | cxTranslate }}</ng-container>
              <ng-container *ngSwitchCase="'orderNumber'">{{ 'orders.orderNumber' | cxTranslate }}</ng-container>
              <ng-container *ngSwitchCase="'itemNumber'">{{ 'orders.itemNumber' | cxTranslate }}</ng-container>
              <ng-container *ngSwitchCase="'poNumber'">{{ 'orders.poNumber' | cxTranslate }}</ng-container>
              <ng-container *ngSwitchCase="'invoiceNumber'">{{ 'orders.invoiceNumber' | cxTranslate }}</ng-container>
            </ng-container>
          </mat-select-trigger>
          <mat-option value="orderNumber" class="js-order-details-filter-searchBy">{{
            'orders.orderNumber' | cxTranslate
          }}</mat-option>
          <mat-option
            *ngIf="!getOrderSearchHideItemNumberEnabled"
            value="itemNumber"
            class="js-order-details-filter-searchBy"
            >{{ 'orders.itemNumber' | cxTranslate }}</mat-option
          >
          <mat-option value="poNumber" class="js-order-details-filter-searchBy">{{
            'orders.poNumber' | cxTranslate
          }}</mat-option>
          <mat-option
            *ngIf="!(backorder && features.hideInvoiceNumber)"
            value="invoiceNumber"
            class="js-order-details-filter-searchBy"
            >{{ 'orders.invoiceNumber' | cxTranslate }}</mat-option
          >
        </mat-select>
      </mat-form-field>
      <div style="max-width: 0; max-height: 0; overflow: hidden">
        <input autofocus="true" />
      </div>
      <mat-form-field appearance="outline" class="search-input">
        <mat-label>{{ 'orders.search' | cxTranslate }}</mat-label>
        <input
          [(ngModel)]="searchField"
          matInput
          placeholder="{{ 'orders.search' | cxTranslate }}"
          (focusout)="newSearch($event)"
          (keydown.enter)="$event.target.blur(); (false)"
          class="js-order-details-filter-searchText"
        />
        <mat-icon class="material-icons-sharp light search-icon" matSuffix *ngIf="!searchField">search</mat-icon>
        <mat-icon
          class="material-icons-sharp light cancel-icon"
          matSuffix
          (click)="clearSearchField()"
          *ngIf="searchField"
          >cancel</mat-icon
        >
      </mat-form-field>
      @if (!(backorder && features.hideInvoiceNumber)) {
      <p class="description">{{ 'orders.searchDescription' | cxTranslate }}</p>
      } @else {
      <p class="description">{{ 'orders.backOrderSearchDescription' | cxTranslate }}</p>
      }
    </div>
    <!-- HIDE as per GB2B-8122 if articles in backorder is hidden -->
    <ng-container *ngIf="backOrderFeature">
      <hr />
      <div class="order-view-wrapper" [ngClass]="activeLanguage$ | async">
        <p class="label">{{ 'orders.view' | cxTranslate }}</p>
        <button
          mat-button
          class="btn not-selected-btn"
          [ngClass]="{ 'selected-btn': !this.backorder && !this.invoice }"
          [disabled]="this.disableOrderHistoryBtn"
          (click)="updateState($event, 'orders'); disableBtn()"
        >
          {{ 'orders.orderHistory' | cxTranslate }}</button
        ><button
          *ngIf="backOrderFeature && isCustomTranslationsEnabled !== null"
          mat-button
          class="btn not-selected-btn"
          [ngClass]="{ 'selected-btn': this.backorder }"
          [disabled]="this.disableBackOrderBtn"
          (click)="updateState($event, 'backorder'); disableBtn()"
        >
          {{
            translatables.orderViewBackorderBtn
              | cxTranslate
                : {
                    context: setCustomContext(
                      isCustomTranslationsEnabled,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </button>
        @if (features.invoiceHistoryEnabled) {
        <button
          class="btn not-selected-btn"
          mat-button
          [ngClass]="{ 'selected-btn': this.invoice }"
          (click)="updateState($event, 'invoice'); disableBtn()"
          [disabled]="this.disableInvoiceBtn"
        >
          {{ 'orders.invoice' | cxTranslate }}
        </button>
        }
      </div>
    </ng-container>
    <div class="desktop-orders" *ngIf="this.isDesktop">
      <hr />
      <div class="order-status-wrapper">
        <p class="label">{{ 'orders.orderStatus' | cxTranslate }}</p>
        <button
          mat-button
          class="btn btn-open"
          [ngClass]="{ 'order-status-selected': this.statusOpen }"
          [disabled]="disableOrderStatus('open')"
          (click)="onClickStatus($event, 'open')"
        >
          <mat-icon svgIcon="open" class="mat-icon"></mat-icon>{{ 'orders.open' | cxTranslate }}</button
        ><button
          mat-button
          class="btn btn-closed"
          [ngClass]="{ 'order-status-selected': this.statusClosed }"
          [disabled]="disableOrderStatus('closed')"
          (click)="onClickStatus($event, 'closed')"
        >
          <mat-icon svgIcon="closed" class="mat-icon"></mat-icon>{{ 'orders.closed' | cxTranslate }}
        </button>
        <button
          mat-button
          *ngIf="isCustomTranslationsEnabled !== null"
          class="btn btn-back-order"
          [ngClass]="{ 'order-status-selected': this.statusBackOrder }"
          [disabled]="disableOrderStatus('backorder')"
          (click)="onClickStatus($event, 'backorder')"
        >
          <mat-icon svgIcon="back-order" class="mat-icon"></mat-icon
          >{{
            'orders.backOrder'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isCustomTranslationsEnabled,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </button>
      </div>
      <hr />
      <div class="order-type-wrapper" [ngClass]="activeLanguage$ | async">
        <p class="label">{{ 'orders.orderType' | cxTranslate }}</p>
        @for (order of orderHistoryTypes; track order.type; let i = $index) { @if (order.show) {
        <button
          mat-button
          class="btn not-selected-btn"
          [ngClass]="{ 'selected-btn': order.selected }"
          [disabled]="order.disabled"
          (click)="onClickType($event, i)"
        >
          {{ order.label | cxTranslate }}
        </button>
        } }
      </div>
      <hr />
      <div class="order-date-wrapper">
        <p class="label">{{ translatables.orderDate | cxTranslate }}</p>
        <div class="content-wrapper">
          <div class="from-date-wrapper">
            <span class="label">{{ translatables.orderDateFrom | cxTranslate }} </span>
            <span
              ><mat-form-field appearance="outline">
                <input
                  [(ngModel)]="fromDateInput"
                  #fromInput
                  matInput
                  [matDatepicker]="fromDate"
                  readonly
                  (dateInput)="onChangeDate($event, 'fdate')"
                  class="js-order-details-from-date-wrapper"
                />
                <mat-datepicker-toggle matSuffix [for]="fromDate">
                  <mat-icon *ngIf="!fromDate.opened" matDatepickerToggleIcon class="material-icons mat-icon"
                    >calendar_today</mat-icon
                  >
                  <mat-icon *ngIf="fromDate.opened" matDatepickerToggleIcon class="calendar-arrow-icon"
                    >keyboard_arrow_down</mat-icon
                  >
                </mat-datepicker-toggle>
                <mat-datepicker #fromDate></mat-datepicker> </mat-form-field
            ></span>
          </div>
          <div class="to-date-wrapper">
            <span class="label">{{ translatables.orderDateTo | cxTranslate }}</span>
            <span>
              <mat-form-field appearance="outline">
                <input
                  [(ngModel)]="toDateInput"
                  #toInput
                  matInput
                  [matDatepicker]="toDate"
                  readonly
                  (dateInput)="onChangeDate($event, 'tdate')"
                  class="js-order-details-from-date-wrapper"
                />
                <mat-datepicker-toggle matSuffix [for]="toDate">
                  <mat-icon *ngIf="!toDate.opened" matDatepickerToggleIcon class="material-icons"
                    >calendar_today</mat-icon
                  >
                  <mat-icon *ngIf="toDate.opened" matDatepickerToggleIcon class="calendar-arrow-icon"
                    >keyboard_arrow_down</mat-icon
                  >
                </mat-datepicker-toggle>
                <mat-datepicker #toDate></mat-datepicker>
              </mat-form-field>
            </span>
          </div>
          <mat-error class="mat-error todate-error" *ngIf="this.hasError">{{
            'orders.toDateGreater' | cxTranslate
          }}</mat-error>
        </div>
      </div>
      <hr />
    </div>
    <div class="mobile-filter-wrapper" *ngIf="!this.isDesktop">
      <hr class="top-wrapper" />
      <div (click)="onClickOpenFilter(1)" class="main-wrapper">
        <span>{{ 'orders.orderStatus' | cxTranslate }}</span
        ><span><mat-icon class="material-icons-sharp light arrow-icon">keyboard_arrow_right</mat-icon></span>
      </div>
      <hr class="bottom-wrapper" />
      <div (click)="onClickOpenFilter(2)" class="main-wrapper">
        <span>{{ 'orders.orderType' | cxTranslate }}</span
        ><span><mat-icon class="material-icons-sharp light arrow-icon">keyboard_arrow_right</mat-icon></span>
      </div>
      <hr class="bottom-wrapper" />
      <div class="main-wrapper" (click)="onClickOpenFilter(3)">
        <span>{{ translatables.orderDate | cxTranslate }}</span
        ><span><mat-icon class="material-icons-sharp light arrow-icon">keyboard_arrow_right</mat-icon></span>
      </div>
    </div>
  </div>
  <div class="order-history-filter mobile-tablet" *ngIf="this.filterType === 1 && !this.isDesktop">
    <div class="order-status-inner" (click)="onClickOpenFilter(0)">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span class="label">{{ 'orders.orderStatus' | cxTranslate }}</span>
    </div>
    <hr />
    <div class="order-status-wrapper">
      <button
        mat-button
        class="btn btn-open"
        [ngClass]="{ 'order-status-selected': this.statusOpen }"
        [disabled]="disableOrderStatus('open')"
        (click)="onClickStatus($event, 'open')"
      >
        <mat-icon svgIcon="open" class="mat-icon"></mat-icon>{{ 'orders.open' | cxTranslate }}</button
      ><button
        mat-button
        class="btn btn-closed"
        [ngClass]="{ 'order-status-selected': this.statusClosed }"
        [disabled]="disableOrderStatus('closed')"
        (click)="onClickStatus($event, 'closed')"
      >
        <mat-icon svgIcon="closed" class="mat-icon"></mat-icon>{{ 'orders.closed' | cxTranslate }}
      </button>
      <button
        mat-button
        class="btn btn-back-order"
        [ngClass]="{ 'order-status-selected': this.statusBackOrder }"
        [disabled]="disableOrderStatus('backorder')"
        (click)="onClickStatus($event, 'backorder')"
      >
        <mat-icon svgIcon="back-order" class="mat-icon"></mat-icon>{{ 'orders.backOrder' | cxTranslate }}
      </button>
    </div>
  </div>
  <div class="order-history-filter mobile-tablet" *ngIf="this.filterType === 2">
    <div class="order-status-inner" (click)="onClickOpenFilter(0)">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span class="label">{{ 'orders.orderType' | cxTranslate }}</span>
    </div>
    <hr />
    <div class="order-type-wrapper" [ngClass]="activeLanguage$ | async">
      @for (order of orderHistoryTypes; track order.type; let i = $index) { @if (order.show) {
      <button
        mat-button
        class="btn not-selected-btn"
        [ngClass]="{ 'selected-btn': order.selected }"
        [disabled]="order.disabled"
        (click)="onClickType($event, i)"
      >
        {{ order.label | cxTranslate }}
      </button>
      } }
    </div>
  </div>
  <div class="order-history-filter mobile-tablet" *ngIf="this.filterType === 3">
    <div class="order-status-inner" (click)="onClickOpenFilter(0)">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span class="label">{{ translatables.orderDate | cxTranslate }}</span>
    </div>
    <hr />
    <div *ngIf="!this.isMobile" class="order-date-wrapper">
      <div class="content-wrapper">
        <div class="from-date-wrapper">
          <span class="label">{{ translatables.orderDateFrom | cxTranslate }} </span>
          <span
            ><mat-form-field appearance="outline">
              <input
                [(ngModel)]="fromDateInput"
                #fromInput
                matInput
                [matDatepicker]="fromDate"
                readonly
                (dateInput)="onChangeDate($event, 'fdate')"
              />
              <mat-datepicker-toggle matSuffix [for]="fromDate">
                <mat-icon *ngIf="!fromDate.opened" matDatepickerToggleIcon class="material-icons mat-icon"
                  >calendar_today</mat-icon
                >
                <mat-icon *ngIf="fromDate.opened" matDatepickerToggleIcon class="date-order"
                  >keyboard_arrow_down</mat-icon
                >
              </mat-datepicker-toggle>
              <mat-datepicker #fromDate></mat-datepicker> </mat-form-field
          ></span>
        </div>
        <div class="to-date-wrapper">
          <span class="label">{{ translatables.orderDateTo | cxTranslate }}</span>
          <span
            ><mat-form-field appearance="outline">
              <input
                [(ngModel)]="toDateInput"
                #toInput
                matInput
                [matDatepicker]="toDate"
                readonly
                (dateInput)="onChangeDate($event, 'tdate')"
              />
              <mat-datepicker-toggle matSuffix [for]="toDate">
                <mat-icon *ngIf="!toDate.opened" matDatepickerToggleIcon class="material-icons"
                  >calendar_today</mat-icon
                >
                <mat-icon *ngIf="toDate.opened" matDatepickerToggleIcon class="date-order"
                  >keyboard_arrow_down</mat-icon
                >
              </mat-datepicker-toggle>
              <mat-datepicker #toDate></mat-datepicker> </mat-form-field
          ></span>
        </div>
        <mat-error class="mat-error todate-error" *ngIf="this.hasError">{{
          'orders.toDateGreater' | cxTranslate
        }}</mat-error>
      </div>
    </div>
    <div *ngIf="this.isMobile" class="order-date-wrapper">
      <div class="content-wrapper">
        <div class="from-date-wrapper">
          <span class="label">{{ translatables.orderDateFrom | cxTranslate }} </span>
          <span
            ><mat-form-field appearance="outline">
              <input
                [(ngModel)]="fromDateInput"
                #fromInput
                matInput
                [matDatepicker]="fromDate"
                readonly
                (dateInput)="onChangeDate($event, 'fdate')"
              />
              <mat-datepicker-toggle matSuffix [for]="fromDate">
                <mat-icon *ngIf="!fromDate.opened" matDatepickerToggleIcon class="material-icons mat-icon"
                  >calendar_today</mat-icon
                >
                <mat-icon *ngIf="fromDate.opened" matDatepickerToggleIcon class="date-order"
                  >keyboard_arrow_down</mat-icon
                >
              </mat-datepicker-toggle>
              <mat-datepicker touchUi="true" #fromDate></mat-datepicker> </mat-form-field
          ></span>
        </div>
        <div class="to-date-wrapper">
          <span class="label">{{ translatables.orderDateTo | cxTranslate }}</span>
          <span
            ><mat-form-field appearance="outline">
              <input
                [(ngModel)]="toDateInput"
                #toInput
                matInput
                [matDatepicker]="toDate"
                readonly
                (dateInput)="onChangeDate($event, 'tdate')"
              />
              <mat-datepicker-toggle matSuffix [for]="toDate">
                <mat-icon *ngIf="!toDate.opened" matDatepickerToggleIcon class="material-icons"
                  >calendar_today</mat-icon
                >
                <mat-icon *ngIf="toDate.opened" matDatepickerToggleIcon class="date-order"
                  >keyboard_arrow_down</mat-icon
                >
              </mat-datepicker-toggle>
              <mat-datepicker touchUi="true" #toDate></mat-datepicker> </mat-form-field
          ></span>
        </div>
        <mat-error class="mat-error todate-error" *ngIf="this.hasError">{{
          'orders.toDateGreater' | cxTranslate
        }}</mat-error>
      </div>
    </div>
  </div>
</ng-container>
<!-- SIDE NAV CLEAR FILTER BOTTOM-->
<ng-container *ngIf="isNonDesktop$ | async">
  <div class="bottom-clear-filter">
    <button class="secondary-btn" mat-button (click)="onClearFilters()">
      {{ 'orders.clearFilters' | cxTranslate }}
    </button>
  </div>
</ng-container>
